export default "__VITE_ASSET__CZetZNA0__"